import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import gql from 'graphql-tag';
import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from '@apollo/client';
import { Observable, of } from 'rxjs';
import { environment } from '@/environment';
import { StrapiParserService } from '@/shared/services';

export const FAULT_ARTICLE_QUERY = gql`
  query FaultArticleQuery($uid: [String!], $publicationState: PublicationState!) {
    faultArticles(where: { uid_in: $uid }, publicationState: $publicationState) {
      metaTagSection {
        name
        content
      }
      uid
      titleOfTheBrowser
      articleTemplate {
        id
        heading1
        icon {
          id
          url
        }
        breadcrumbs
        pageContent
      }
      elements {
        ... on ComponentElementsGlobalComponent {
          genericComponent {
            genericElementType {
              title
              uid
            }
            type
            uid
            title
            subtitle
            copy
            icon {
              url
              webPURL
            }
            ctas {
              Uid
              label
              url
              targetNewPage
              alt
              contentUid
              targetList
              behavior
              dataAttr
              dataAttrValue
              icon {
                url
                webPURL
              }
            }
            listOfContent {
              text
              content
            }
            fa_icon_name
            fa_icon_weight
            fa_icon_color
            listOfLinks {
              links {
                label
                icon {
                  url
                  webPURL
                }
                url
                alt
                contentUid
              }
            }
            KeyValue {
              id
              key
              uuid
              value {
                id
                value
                uuid
              }
            }
            externalUrl
          }
        }
        ... on ComponentElementsGenericComponent {
          type
          title
          subtitle
          copy
          icon {
            url
            webPURL
          }
          ctas {
            label
            url
            targetNewPage
            alt
            contentUid
            targetList
            behavior
            dataAttr
            dataAttrValue
            icon {
              url
              webPURL
            }
          }
          externalUrl
          listOfContent {
            text
            content
          }
          KeyValue {
            id
            key
            uuid
            value {
              id
              value
              uuid
            }
          }
          fa_icon_name
          fa_icon_weight
          fa_icon_color
          listOfLinks {
            links {
              label
              icon {
                url
                webPURL
              }
              url
              alt
            }
          }
        }

        ... on ComponentElementsListOfLinks {
          links {
            label
            icon {
              url
              webPURL
            }
            url
          }
        }

        ... on ComponentElementsContent {
          content
        }

        ... on ComponentElementsMultiLevel {
          Level1 {
            Level1_title
            Level1_content
            ctas {
              label
              url
            }
            Level1_media {
              media {
                url
                alternativeText
                ext
                name
                webPURL
              }
            }
            Level2 {
              Level2_title
              Level2_content
              Level2_media {
                media {
                  url
                  webPURL
                }
                desktopImagePosition {
                  position
                }
              }
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AtomicArticleService {
  private strapiParserService = inject(StrapiParserService);
  private apollo = inject(Apollo);

  getArticles(uidList): Observable<any> {
    if (uidList) {
      return this.apollo
        .query({
          query: FAULT_ARTICLE_QUERY,
          fetchPolicy: 'no-cache',
          variables: {
            uid: uidList,
            publicationState: environment.production ? 'LIVE' : 'PREVIEW',
          },
        })
        .pipe(
          map(({ data }: ApolloQueryResult<any>) => {
            const faultArticles = [];
            data?.faultArticles.forEach((article) => {
              faultArticles.push(this.strapiParserService.applyUpdates(article));
            });
            return faultArticles;
          })
        );
    } else {
      return of({});
    }
  }
}
